// Centralized analytics event definitions for GA4 tracking
export const trackEvent = (eventName: string, params?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, params);
    console.debug(`[Analytics] Tracked event: ${eventName}`, params);
  } else {
    console.debug(`[Analytics (Dev Mode)] Would track: ${eventName}`, params);
  }
};

export const EVENTS = {
  CTA_CLICK: 'cta_click',
  CALCULATOR_INTERACT: 'calculator_interact', 
  CALCULATOR_SLIDER_MOVE: 'calculator_slider_move',
  FORM_SUBMIT: 'form_submit',
  FORM_FIELD_FOCUS: 'form_field_focus',
  SCROLL_MILESTONE: 'scroll_milestone',
  ASSUMPTION_TOGGLE: 'assumption_toggle',
  ZALO_CLICK: 'zalo_click',
} as const;
